module.exports = __webpack_public_path__ + "static/img/72041B_1_2_R_20200912_LC.3c70de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72041B_1_2_R_20200912_LC.png
// module id = bt4p
// module chunks = 0